export default __webpack_public_path__ + "static/media/Amulet of the Hell Walker.d66e3071.jpg";